import React from 'react'
import { CountBubble } from '../ui/CountBubble'

export function SupportUnreadBadge({ count }: { count: number }) {
  if (!count) return null
  return <CountBubble count={count} size={18} accessibilityLabel={`${count} unread messages`} />
}
